<template>
    <transition name="slide">
        <div class="item-tray tip">
            <b-container>
                <ion-icon @click="close" name="play" class="close-icon"></ion-icon>
                <h5 class="pb-4 text-center">Please add the tip below.</h5>
                <b-input-group prepend="£">
                    <b-form-input type="tel" v-model="tip"></b-form-input>
                </b-input-group>
                <b-btn class="mt-4" size="lg" variant="primary" @click="addTip" block>Add tip</b-btn>
            </b-container>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "TipSheet",

        data() {
            return {
                tip: ''
            }
        },

        methods: {
            close() {
                this.$emit('close');
            },
            addTip() {
                this.$emit('tip', this.tip)
            }
        }
    }
</script>

<style scoped>
    .slide-enter-active {
        animation: slide-in .5s;
    }

    .slide-leave-active {
        animation: slide-in .5s reverse;
    }

    @keyframes slide-in {
        0% {
            transform: translateY(100%);
        }
        100% {
            transform: translateY(0);
        }
    }
</style>